// extracted by mini-css-extract-plugin
export default {"placeholder":"PlaceholderSection_placeholder__qRFIY","messageStack":"PlaceholderSection_messageStack__221zn"};